import React, { useEffect } from "react";
import "./Toast.css";

interface ToastProps {
  message:  string | null;
  variant?: "success" | "info" | "error";
  onClose:  () => void;
}

export default function Toast({ message, variant = "success", onClose }: ToastProps) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClose, 4000);
    return () => clearTimeout(t);
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className={`toast toast--${variant}`} role="status">
      <span className="toast__message">{message}</span>
      <button className="toast__close" onClick={onClose} aria-label="Dismiss">×</button>
    </div>
  );
}
